document.addEventListener('DOMContentLoaded', () => {
  const mount = document.getElementById('cart-ui-mount');
  if (!mount) return;

  fetch('/shop/checkout/cart-ui?v=' + Date.now(), {
    credentials: 'include',
    cache: 'no-store',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(async (r) => {
      if (!r.ok) throw new Error(r.status + ' ' + r.statusText);
      const html = await r.text();
      mount.innerHTML = html;
    })
    .catch((e) => {
      console.error('Cart UI load failed:', e);
      mount.innerHTML = '<p style="color:red;text-align:center;">Failed to load cart.</p>';
    });
});